import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=00e0b133&scoped=true&"
import script from "./contentDetail.vue?vue&type=script&lang=js&"
export * from "./contentDetail.vue?vue&type=script&lang=js&"
import style0 from "./contentDetail.vue?vue&type=style&index=0&id=00e0b133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e0b133",
  null
  
)

export default component.exports